import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { PanelConfigI } from '../../interfaces/configs/panel-config-i';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'co-panel',
  imports: [PanelModule,TranslatePipe],
  templateUrl: './panel.component.html',
  styleUrl: './panel.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelComponent {
  config: InputSignal<PanelConfigI> = input.required();
}
